<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>language</md-icon>
          </div>
          <h4 class="title">翻訳済みテキスト詳細</h4>
        </md-card-header>
        
        <md-card-content class="md-layout formLayout">
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              ブランド名
            </label>
            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <md-field class="readonly-field"><md-input v-model="brandName" class="readonlyBg" :readonly="true"></md-input></md-field>
            </div> 
          </div>
          
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              日本語
            </label>
            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <md-field class="readonly-field"><md-input v-model="nameJa" class="readonlyBg" :readonly="true"></md-input></md-field>
            </div>
          </div>
          
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              英語
            </label>
            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <md-field>
                <md-input v-model="nameEn" v-validate="modelValidations.nameEn" :class="{'md-invalid': errors.has('nameEn') && touched.nameEn}" data-vv-name="nameEn" data-vv-as="英語"></md-input>
                <span class="md-error" v-if="errors.has('nameEn') && touched.nameEn">{{ errors.first('nameEn') }}</span>
              </md-field>
            </div>
          </div>
          
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              簡体字中国語
            </label>
            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <md-field>
                <md-input v-model="nameCn" v-validate="modelValidations.nameCn" :class="{'md-invalid': errors.has('nameCn') && touched.nameCn}" data-vv-name="nameCn" data-vv-as="簡体字中国語"></md-input>
                <span class="md-error" v-if="errors.has('nameCn') && touched.nameCn">{{ errors.first('nameCn') }}</span>
              </md-field>
            </div>
          </div>
          
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              繁体字中国語
            </label>
            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <md-field>
                <md-input v-model="nameTw" v-validate="modelValidations.nameTw" :class="{'md-invalid': errors.has('nameTw') && touched.nameTw}" data-vv-name="nameTw" data-vv-as="繁体字中国語"></md-input>
                <span class="md-error" v-if="errors.has('nameTw') && touched.nameTw">{{ errors.first('nameTw') }}</span>
              </md-field>
            </div>
          </div>
          
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              韓国語
            </label>
            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <md-field>
                <md-input v-model="nameKo" v-validate="modelValidations.nameKo" :class="{'md-invalid': errors.has('nameKo') && touched.nameKo}" data-vv-name="nameKo" data-vv-as="韓国語"></md-input>
                <span class="md-error" v-if="errors.has('nameKo') && touched.nameKo">{{ errors.first('nameKo') }}</span>
              </md-field>
            </div>
          </div>
        </md-card-content>
        
        <md-card-actions md-alignment="left" class="mt60 mx-auto no-border">
          <md-button class="md-warning md-lg" @click.native.prevent="returnBack">戻る</md-button>
          <md-button class="md-success md-lg mL40" @click.native.prevent="validate">更新</md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
  import router from '../packs/router.js'
  import constants from '../mixins/constants.js'
  import alert from '../mixins/alert.js'

  export default {
    mixins: [constants, alert],
    components: {
    },
    data () {
      return {
        id: '',
        brandId: '',
        brandName: '',
        nameJa: '',
        nameEn: '',
        nameCn: '',
        nameTw: '',
        nameKo: '',
        touched: {
          nameEn: false,
          nameCn: false,
          nameTw: false,
          nameKo: false
        },
        modelValidations: {
          nameEn: {
            max: 255
          },
          nameCn: {
            max: 255
          },
          nameTw: {
            max: 255
          },
          nameKo: {
            max: 255
          }
        }
      }
    },
    methods: {
      returnBack () {
        router.push({ path: '/admin/glossary_list' })
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.updateGlossary()
          } else {
            this.dangerNotify('255文字以内で入力してください')
          }
        })
      },
      updateGlossary () {
        var condition = {
          glossary: {
            brand_id: this.brandId,
            name_en: this.nameEn,
            name_cn: this.nameCn,
            name_tw: this.nameTw,
            name_ko: this.nameKo
          }
        }

        this.axios({
          method  : 'PUT',
          url     : this.AdminApiUrl + '/glossaries/' + this.$route.params.id,
          timeout : 30000,
          data: condition,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.successAndBackPage(`翻訳済みテキストを更新しました`)
        })
        .catch(error => {
          console.log('API Error:', error)
          if (error.response && error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('翻訳済みテキストの更新に失敗しました')
          }
        })
      },
      getGlossary () {
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/glossaries/' + this.$route.params.id,
          timeout : 10000,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.id = response.data.id
          this.brandId = response.data.brand_id || ''
          this.brandName = response.data.brand_name || ''
          this.nameJa = response.data.name_ja || ''
          this.nameEn = response.data.name_en || ''
          this.nameCn = response.data.name_cn || ''
          this.nameTw = response.data.name_tw || ''
          this.nameKo = response.data.name_ko || ''
        })
        .catch(error => {
          console.log('API Error:', error)
          if (error.response && error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('翻訳情報の取得に失敗しました')
          }
        })
      }
    },
    mounted () {
      this.getGlossary()
    },
    watch: {
      nameEn(){
        this.touched.nameEn = true
      },
      nameCn(){
        this.touched.nameCn = true
      },
      nameTw(){
        this.touched.nameTw = true
      },
      nameKo(){
        this.touched.nameKo = true
      }
    }
  }
</script>

<style scoped>
.readonlyBg{
  background-color: rgb(211, 211, 211);
  padding-left: 5px;
  pointer-events: none;
}

.formLayout{
  flex-basis: auto;
}

.mt60{
  margin-top: 60px;
}

.no-border{
  border-top: none !important;
}

/* 読み取り専用フィールドのアニメーション無効化 */
.md-field.readonly-field {
  pointer-events: none;
}

.md-field.readonly-field .md-input {
  pointer-events: none;
}

.md-field.readonly-field::before,
.md-field.readonly-field::after {
  display: none !important;
}

@media screen and (max-width:600px) {
  .md-card .md-card-content .md-form-label{
    text-align: left;
  }
}
</style> 